module.exports = __webpack_public_path__ + "img/cancel.ddfb2a4a.svg";